export const fishStates = [
  {
    id: '01_loop',
    duration: 4300,
    loop: true,
    amountOfFrames: 93,
  },
];
